<script>

import { Bus } from '@/main'
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities'
import { collect } from 'collect.js'

export default {
  extends: Line,
  props: ['height', 'width'],
  data: function () {
    return {
      brandPrimary: getStyle('--primary') || '#20a8d8',
      days: 7
    }
  },
  methods: {
    createChart (data) {
      const numberOfDays = this.$moment().subtract(this.days, 'days').format('YYYY-MM-DD')
      const datasets1 = [
        {
          label: 'Requests:',
          backgroundColor: this.brandPrimary,
          borderColor: 'rgba(255,255,255,.55)',
          data: collect(data.data).where('created_at', '>', numberOfDays).pluck('requests').all()
        }
      ]
      this.renderChart(
        {
          labels: collect(data.data).where('created_at', '>', numberOfDays).pluck('day').map((item) => {
            return this.$moment(item, 'DD-MM-YYYY').format('DD/MM')
          }).all(),
          datasets: datasets1
        },
        {
          tooltips: {
            enabled: false,
            custom: CustomTooltips
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  color: 'transparent',
                  zeroLineColor: 'transparent'
                },
                ticks: {
                  fontSize: 2,
                  fontColor: 'transparent'
                }
              }
            ],
            yAxes: [
              {
                display: false,
                ticks: {
                  display: false,
                  min: Math.min.apply(Math, datasets1[0].data) - 5,
                  max: Math.max.apply(Math, datasets1[0].data) + 5
                }
              }
            ]
          },
          elements: {
            line: {
              borderWidth: 1
            },
            point: {
              radius: 4,
              hitRadius: 10,
              hoverRadius: 4
            }
          }
        }
      )
    }
  },
  created () {
    Bus.$on('oneMonthStatistics', (data) => {
      this.createChart(data)
    })
  }
}
</script>
